import superagent from 'superagent'

import {
  setUploadingStatus,
  setProgressAmount,
  setErrorUpload,
} from 'reduxpath/ducks/Upload'

import { universeHost } from 'configpath'

export default function GeneralUploadFile(
  dispatch,
  data,
  progressCb = (progress) => {
    dispatch(setProgressAmount(progress.percent || 0))
    if (progress.percent === 100) {
      dispatch(setUploadingStatus(false))
      dispatch(setProgressAmount(0))
    }
  },
) {
  dispatch(setUploadingStatus(true))

  const { filename, file, pathName, secret } = data

  const fd = new FormData()
  fd.append('file', file)
  fd.append('filename', filename || file.name)
  fd.append('group', pathName)

  if (secret) {
    fd.append('secret', secret)
  }

  const result = superagent
    .post(`${universeHost}/compute/files`)
    .send(fd)
    .on('progress', progressCb)
    .then(res => res.body)
    .catch((err) => {
      const errorData = {
        isDirectUploadError: true,
        errorDirectUpload:
          'Upload failed, please make sure your device is connected to the internet',
      }
      dispatch(setErrorUpload(errorData))
      return err
    })

  return result
}

export function GeneralRemoveFile(data) {
  const { fileName, fileUrlRaw } = data

  const payload = {
    fileName,
    fileUrlRaw,
  }

  const result = superagent
    .post(`${universeHost}/compute/files/delete`)
    .send(payload)
    .then(res => res.body)
    .catch((err) => {
      const errorData = {
        isDirectUploadError: true,
        errorDirectUpload:
          'Delete file failed, please make sure your device is connected to the internet',
      }
      console.error(errorData)
      return err
    })

  return result
}
